import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaBookOpen,
  FaCreditCard,
  FaFilePdf,
  FaBook,
  FaCheck
} from 'react-icons/fa';

import '../styles/DigitalProducts.css';

const DigitalProducts = () => {

  // Free sample Google Drive link
  const freeSampleLink =
    'https://drive.google.com/file/d/1hMu-6_L-lb5Q-yGG8JQlhB7fCd9aSxpD/view?usp=sharing';

  return (
    <div className="digital-products-page">

      {/* =========================
          HERO SECTION
      ========================== */}

      <section className="digital-header">

        <div className="digital-header-content">

          <span className="digital-badge">
            <FaBookOpen />
            DIGITAL PRODUCTS
          </span>

          <h1>
            Learn More. Prepare Better.
            <br />
            <span>Achieve Your Goals.</span>
          </h1>

          <p>
            Get practical digital guides created to help
            Ethiopian students and aspiring travelers access
            useful information, opportunities, and resources.
          </p>

        </div>

      </section>


      {/* =========================
          PRODUCTS SECTION
      ========================== */}

      <section className="products-section">

        <div className="products-container">


          {/* =========================
              FREE SAMPLE PRODUCT
          ========================== */}

          <div className="product-card free-card">

            <div className="product-icon">
              <FaBookOpen />
            </div>

            <span className="product-label free-label">
              FREE SAMPLE
            </span>

            <h2>
              Chinese Scholarship 2026 Guide
            </h2>

            <p className="product-description">
              Explore the free sample edition of the
              Chinese Scholarship 2026 Guide and discover
              how the complete guide can help you prepare
              your scholarship application.
            </p>

            <div className="product-features">

              <p>
                <FaCheck />
                Scholarship introduction
              </p>

              <p>
                <FaCheck />
                Basic requirements
              </p>

              <p>
                <FaCheck />
                Application timeline
              </p>

              <p>
                <FaCheck />
                Common mistakes
              </p>

              <p>
                <FaCheck />
                Sample guide pages
              </p>

            </div>


            {/* FREE SAMPLE BUTTON */}

            <a
              href={freeSampleLink}
              target="_blank"
              rel="noopener noreferrer"
              className="product-button free-button"
            >
              <FaBookOpen />
              Read Free Sample
            </a>

          </div>


          {/* =========================
              PAID FULL GUIDE
          ========================== */}

          <div className="product-card paid-card">

            <div className="product-icon">
              <FaBook />
            </div>

            <span className="product-label paid-label">
              FULL GUIDE
            </span>

            <h2>
              Chinese Scholarship 2026 Guide for Ethiopians
            </h2>

            <p className="product-description">
              Get the complete digital guide with detailed
              scholarship information, preparation steps,
              useful resources, application guidance,
              checklists, and more.
            </p>

            <div className="product-features">

              <p>
                <FaCheck />
                Complete scholarship guide
              </p>

              <p>
                <FaCheck />
                Document preparation
              </p>

              <p>
                <FaCheck />
                Application timeline
              </p>

              <p>
                <FaCheck />
                University deadline tracker
              </p>

              <p>
                <FaCheck />
                Printable checklist
              </p>

              <p>
                <FaCheck />
                Detailed application guidance
              </p>

            </div>


            {/* PRICE */}

            <div className="price">
              <span>499</span> ETB
            </div>


            {/* BUY BUTTON */}

            <Link
              to="/digital-products/chinese-scholarship"
              className="product-button paid-button"
            >
              <FaCreditCard />
              Buy Full Guide
            </Link>

          </div>

        </div>

      </section>


      {/* =========================
          TRUST / INFORMATION SECTION
      ========================== */}

      <section className="digital-info">

        <div className="digital-info-container">

          <h2>
            Simple & Easy Access
          </h2>

          <div className="info-items">


            {/* STEP 1 */}

            <div className="info-item">

              <div className="info-icon">
                <FaBookOpen />
              </div>

              <h3>
                Read the Sample
              </h3>

              <p>
                Access the free sample edition before
                deciding to purchase the complete guide.
              </p>

            </div>


            {/* STEP 2 */}

            <div className="info-item">

              <div className="info-icon">
                <FaCreditCard />
              </div>

              <h3>
                Pay 499 ETB
              </h3>

              <p>
                Purchase the complete guide for only
                499 ETB.
              </p>

            </div>


            {/* STEP 3 */}

            <div className="info-item">

              <div className="info-icon">
                <FaFilePdf />
              </div>

              <h3>
                Receive Your PDF
              </h3>

              <p>
                Send your payment screenshot and receive
                the complete PDF after verification.
              </p>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default DigitalProducts;